export default __webpack_public_path__ + "static/media/temp visa E4 - Highly Qualified Activity Visa.10a6c194.jpg";